<template>
    <div>
        <div v-if="useDevice().isDesktop" class="w-full shadow-xl border border-gray-850 bg-gray-900 p-6 rounded-2xl">
            <div class="flex items-center gap-2 mb-1">
                <AppCoin size="lg" color="gold" />
                <p class="text-title-lg font-bold text-gray-100">{{ creditValue }}</p>
            </div>
            <p class="text-body-md text-gray-600">${{ ratio }} {{ $t("pages_pricing_perPhoto") }}</p>
            <AppRangeSlider max="200" min="5" step="5" v-model="creditValue" class="w-full mt-4" />
        </div>

        <div v-else>
            <p class="text-body-md text-center mb-2 text-gray-600">${{ ratio }} {{ $t("pages_pricing_perPhoto") }}</p>
            <Swiper :slidesPerView="4" :spaceBetween="1" centeredSlides @slideChange="onSlideChange">
                <SwiperSlide v-for="i in 40" v-slot="{ isActive }">
                    <span
                        class="rounded-full text-gray-100 flex mx-auto items-center justify-center h-10 transition-all"
                        :class="isActive ? 'bg-brand-500 text-title-md font-bold' : 'w-10 text-body-lg bg-gray-800'"
                    >
                        <AppCoin v-if="isActive" size="lg" color="gold" class="mr-2" />
                        {{ i * 5 }}
                    </span>
                </SwiperSlide>
            </Swiper>
        </div>
    </div>
</template>

<script setup lang="ts">
interface IProps {
    ratio: number;
}

const props = defineProps<IProps>();

const creditValue = defineModel<number>();
creditValue.value = 5;

const onSlideChange = (swiper: { activeIndex: number }) => {
    creditValue.value = (swiper.activeIndex + 1) * 5;
};

const emit = defineEmits(["change:amount"]);

watch(
    creditValue,
    () => {
        emit("change:amount", ((creditValue.value as number) * props.ratio).toFixed(2));
    },
    { immediate: true }
);

// reset value
onBeforeUnmount(() => {
    creditValue.value = 5;
});
</script>
